import HoldingSettlementPage from './HoldingSettlementPage';
import HoldingSettlementResponseList from '../../components/HoldingSettlement/HoldingSettlementResponseList';

const HoldingSettlementResponse = () => (
    <HoldingSettlementPage
        title="Holding Settlement Response"
        breadcrumbTitle="Holding Settlement Response"
    >
        <HoldingSettlementResponseList />
    </HoldingSettlementPage>
);

export default HoldingSettlementResponse;
